const serializeDashboardFilterRuleForAiContext = ({ id: _id, tileTargets: _tileTargets, lockedTabUuids: _lockedTabUuids, requiredGroupId: _requiredGroupId, sectionId: _sectionId, ...filter }) => filter;
export const serializeDashboardFiltersForAiContext = (filters) => ({
    dimensions: filters.dimensions.map(serializeDashboardFilterRuleForAiContext),
    metrics: filters.metrics.map(serializeDashboardFilterRuleForAiContext),
    tableCalculations: filters.tableCalculations.map(serializeDashboardFilterRuleForAiContext),
});
//# sourceMappingURL=dashboardContext.js.map